import { Tabs } from '@platform/components';
import { AuthedPage, HeaderFooterLayout } from '../../app';
import { OrganizationCards } from './OrganizationCards';
import { ProjectCards } from './ProjectCards';

const getInitialTab = () => {
  if (typeof window === 'undefined') {
    return 'projects';
  }
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('view') === 'organizations' ? 'organizations' : 'projects';
};

const ProjectSearch = () => {
  return (
    <AuthedPage>
      <HeaderFooterLayout useDashboardHeader>
        <div className='flex flex-col gap-4 px-4 py-6 md:px-6 w-full'>
          <div className='text-4xl font-semibold text-gray-900'>
            Find a project or create one with an organization
          </div>
          <Tabs
            title='Find a project or an organization'
            variant='segmented'
            keepTabsOnMobile
            defaultSelectedKey={getInitialTab()}
            items={[
              { id: 'projects', tabLabel: 'Projects', content: <ProjectCards /> },
              { id: 'organizations', tabLabel: 'Organizations', content: <OrganizationCards /> },
            ]}
          />
        </div>
      </HeaderFooterLayout>
    </AuthedPage>
  );
};

export default ProjectSearch;
